import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import '../src/App.css'
import Home from './pages/home';
import About from './pages/About';
import AboutUs from './pages/AboutUs'
import Campus from './pages/Campus'
import OurMotto from './pages/OurMotto';
import MissionVision from './pages/MissionVision';
import PrincipalsMessage from './pages/PrincipalsMessage';
import ChairmanMessage from './pages/ChairmanMessage';
import FounderMessage from './pages/FounderMessage';
import StMaryMessage from './pages/StMaryMessage';
import SchoolPhilosophy from './pages/SchoolPhilosophy';
import StaffDetails from './pages/StaffDetails';
import TeachingSubjects from './pages/TeachingSubjects';
import TeachingPedagogy from './pages/TeachingPedagogy';
import Activities from './pages/Activities';
import AdmissionDetails from './pages/AdmissionDetails';
import Booklist from './pages/Booklist';
import FeeStructure from './pages/FeeStructure';
import Gallery from './pages/Gallery';
import SubGallery from './pages/SubGallery';
import Contact from './pages/Contact';
import TCIssued from './pages/TCIssued';
import SchoolErp from './pages/SchoolErp';
import PortalHelp from './pages/PortalHelp';
import Sitemap from './pages/Sitemap';
import Testimonials from './pages/Testimonials';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="About" element={<About />} />
        <Route path="AboutUs" element={<AboutUs />} />
        <Route path="Campus" element={<Campus />} />
        <Route path='OurMotto' element={<OurMotto />} />
        <Route path='MissionVision' element={<MissionVision />} />
        <Route path='PrincipalsMessage' element={<PrincipalsMessage />} />
        <Route path='ChairmanMessage' element={<ChairmanMessage />} />
        <Route path='FounderMessage' element={<FounderMessage />} />
        <Route path='StMaryMessage' element={<StMaryMessage />} />
        <Route path='SchoolPhilosophy' element={<SchoolPhilosophy />} />
        <Route path='StaffDetails' element={<StaffDetails />} />
        <Route path='TeachingSubjects' element={<TeachingSubjects />} />
        <Route path='TeachingPedagogy' element={<TeachingPedagogy />} />
        <Route path='Activities' element={<Activities />} />
        <Route path='AdmissionDetails' element={<AdmissionDetails />} />
        <Route path='Booklist' element={<Booklist />} />
        <Route path='FeeStructure' element={<FeeStructure />} />
        <Route path='Gallery' element={<Gallery />} />
        <Route path='SubGallery' element={<SubGallery />} />
        <Route path='Contact' element={<Contact />} />
        <Route path='TCIssued' element={<TCIssued />} />
        <Route path='SchoolErp' element={<SchoolErp />} />
        <Route path='PortalHelp' element={<PortalHelp />} />
        <Route path='Sitemap' element={<Sitemap />} />
        <Route path='Testimonials' element={<Testimonials />} />
      </Routes>
    </Router>
  );
}
export default App;
